import { useQuery } from "react-query";
import { getPropertyHazardousObjects } from "../api/api";

export const usePropertyHazardousObjects = (
  propertyId: string,
  token?: string,
  enabled = true
) =>
  useQuery(
    ["propertyHazardousObjects", propertyId],
    () => getPropertyHazardousObjects(propertyId, undefined, token),
    {
      enabled: enabled && !!propertyId,
    }
  );
